import { render, staticRenderFns } from "./Selectize.vue?vue&type=template&id=1fa660d0&lang=html&"
import script from "./Selectize.vue?vue&type=script&lang=js&"
export * from "./Selectize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports